module.exports = __webpack_public_path__ + "img/tm_ico.29a5b018.png";